import './TeacherInvitedAfterMeeting.scss';

export default function TeacherInvitedAfterMeetingInstallExtension({
  onInstall,
  onSkip,
}) {
  return (
    <div className="teacher-invited-about-us">
      <div className="shell">
        <div className="step-eyebrow">Step 3 of 3</div>
        <h1 className="step-h1">Install the browser extension.</h1>
        <p className="step-sub">
          You can get the extension so you’ll understand how students will
        </p>

        <ul className="ext-list">
          <li>Read articles from sources your school subscribes to</li>
          <li>Question, review, and add evidence to claims as you read</li>
          <li>Save articles and quotes to your courses</li>
        </ul>

        <button type="button" className="btn-primary" onClick={onInstall}>
          Install the extension
        </button>
        <div className="skip-row">
          <button type="button" className="btn-text" onClick={onSkip}>
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}
